<template>
  <div>
    <div class="source">
      <el-row class="querypanel">
        <el-col :span="10">
          <div class="leftpanel">
            <div>全国区域信息:</div> <br/>
            <el-tree
              class="filter-tree"
              :data="areadata"
              :props="areaProps"
              default-expand-all
              :expand-on-click-node="false"
              :render-content="area_renderugcontext">
            </el-tree>
            <div class="desinfo"> *请先增加全国区域，然后依次增加，注意总区域只能有一个，总区域下可以设置三级子区域。</div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="rightpanel">
            <el-collapse v-model="area_activeNames" accordion >
              <el-collapse-item title="总区域" name="0">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="总区域名称">
                    <el-input v-model="area_info"></el-input>
                  </el-form-item>
                  <el-form-item label="新增一级区域">
                    <el-input v-model="area_nameone" placeholder="仅新增一级区域时添加"></el-input>
                  </el-form-item>
                  <el-button @click="area_changezero">保存</el-button>
                  <el-button @click="area_addone">新增区域</el-button>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="一级区域" name="1">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前一级区域">
                    <el-input v-model="area_one"></el-input>
                  </el-form-item>
                  <el-form-item label="新增二级区域">
                    <el-input v-model="area_nametwo" placeholder="仅新增二级区域时添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="area_changeone">保存</el-button>
                    <el-button @click="area_addtwo">新增区域</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="二级区域" name="2">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前二级区域">
                    <el-input v-model="area_two"></el-input>
                  </el-form-item>
                  <el-form-item label="新增三级区域">
                    <el-input v-model="area_namethree" placeholder="仅新增三级区域添加"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="area_changetwo">保存</el-button>
                    <el-button @click="area_addthree">新增区域</el-button>
                  </el-form-item>
                  <div>

                  </div>
                </el-form>
              </el-collapse-item>
              <el-collapse-item title="三级区域" name="3">
                <el-form ref="form"  label-width="180px" label-position="left" class="tabcard">
                  <el-form-item label="当前三级区域">
                    <el-input v-model="area_three"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="area_changethree">保存</el-button>
                  </el-form-item>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$http = axios
var that
export default {
  name: 'AllArea',
  data () {
    return {
      khid: '',
      areadata: [],
      area_activeNames: [],
      area_info: '',
      area_one: '',
      area_two: '',
      area_three: '',
      area_nameone: '',
      area_nametwo: '',
      area_namethree: '',
      area_selectnode: '',
      areaProps: {
        children: 'Children',
        label: 'name'
      }
    }
  },
  beforeCreate: function () {
    that = this
  },
  mounted: function () {
    that = this
    console.log('mounted')
    var v = getCookie('cusid')
    that.khid = v
    console.log(that.khid)
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      console.log('获取全国区域信息')
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/gbatree',
        method: 'post',
        data: {
          cusid: {Int64: parseInt(v), Valid: true},
          parentid: {Int64: parseInt(-1), Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          console.log(JSON.parse(res.data.data))
          if (res.data.success) {
            that.areadata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    area_renderugcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span>{data.name}</span>
          </span>
          <span>
            <i class="fa fa-pencil-square-o gtopicon" on-click={ () => this.area_edit(node, data)}> </i>
            <i class="fa fa-trash-o gtopicon" on-click={ () => this.area_remove(node, data)}> </i>
          </span>
        </span>
      )
    },
    area_edit (node, data) {
      console.log(node)
      console.log(data)
      this.area_selectnode = data
      this.area_activeNames = [data.level.Int64.toString()]
      console.log(this.area_activeNames)
      switch (data.level.Int64.toString()) {
        case '0': {
          that.area_info = data.name
          break
        }
        case '1': {
          that.area_one = data.name
          break
        }
        case '2': {
          that.area_two = data.name
          break
        }
        case '3': {
          that.area_three = data.name
          break
        }
      }
    },
    area_remove (node, data) {
      console.log(node)
      console.log(data)
      var idlist = []
      if (data.haschild.Int64 === 0) {
        idlist.push(data.id.Int64)
      } else {
        idlist.push(data.id.Int64)
        var cnode = data.Children
        for (var index in cnode) {
          console.log(cnode[index])
          idlist.push(cnode[index].id.Int64)
          if (cnode[index].haschild.Int64 === 0) {
          } else {
            var cinode = cnode[index].Children
            for (var i in cinode) {
              idlist.push(cinode[i].id.Int64)
              if (cinode[i].haschild.Int64 === 0) {
              } else {
                var ciinode = cinode[i].Children
                for (var j in ciinode.Children) {
                  idlist.push(ciinode.Children[j].id.Int64)
                  if (cinode[i].haschild.Int64 === 0) {
                  } else {
                    for (var k in ciinode.Children) {
                      idlist.push(ciinode.Children[k].id.Int64)
                    }
                  }
                }
              }
            }
          }
        }
      }
      var idstr = 'id in (' + idlist + ')'
      console.log(idstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/badel',
        method: 'post',
        data: {
          whereinfo: {String: idstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.success) {
              that.$http({
                url: 'https://api.sqnetsoft.cn/basedata/gbatree',
                method: 'post',
                data: {
                  cusid: {Int64: parseInt(that.khid), Valid: true},
                  parentid: {Int64: parseInt(-1), Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  that.areadata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_changezero () {
      console.log(this.area_selectnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/baaau',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
          name: {String: this.area_info, Valid: true},
          level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
          haschild: {Int64: parseInt(this.area_selectnode.haschild.Int64), Valid: true},
          parentid: {Int64: parseInt(-1), Valid: true},
          cusid: {Int64: parseInt(this.khid), Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.areadata = JSON.parse(res.data.data)
                if (res.data.success) {
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_changeone () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/baaau',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
          cusid: {Int64: parseInt(this.khid), Valid: true},
          name: {String: this.area_one, Valid: true},
          level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
          haschild: {Int64: parseInt(this.area_selectnode.haschild.Int64), Valid: true},
          parentid: {Int64: parseInt(this.area_selectnode.parentid.Int64), Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.areadata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_changetwo () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/baaau',
        method: 'post',
        data: {
          id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
          cusid: {Int64: parseInt(this.khid), Valid: true},
          name: {String: this.area_two, Valid: true},
          level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
          haschild: {Int64: parseInt(that.area_selectnode.haschild.Int64), Valid: true},
          parentid: {Int64: parseInt(that.area_selectnode.parentid.Int64), Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.areadata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_changethree () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/baaau',
        method: 'post',
        data: {
          id: {Int64: parseInt(that.area_selectnode.id.Int64), Valid: true},
          cusid: {Int64: parseInt(that.khid), Valid: true},
          name: {String: that.area_three, Valid: true},
          level: {Int64: parseInt(that.area_selectnode.level.Int64), Valid: true},
          haschild: {Int64: parseInt(that.area_selectnode.haschild.Int64), Valid: true},
          parentid: {Int64: parseInt(that.area_selectnode.parentid.Int64), Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                if (res.data.success) {
                  that.areadata = JSON.parse(res.data.data)
                  that.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_addone () {
      console.log(this.area_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_info, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
        haschild: {Int64: parseInt(1), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.parentid.Int64), Valid: true}
      }
      var newobj = {
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_nameone, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64) + 1, Valid: true},
        haschild: {Int64: parseInt(0), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true}
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/bapaau',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.areadata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_addtwo () {
      console.log(this.area_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_one, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
        haschild: {Int64: parseInt(1), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.parentid.Int64), Valid: true}
      }
      var newobj = {
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_nametwo, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64) + 1, Valid: true},
        haschild: {Int64: parseInt(0), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true}
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/bapaau',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.areadata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    area_addthree () {
      console.log(this.area_selectnode)
      var newnode = []
      var oldobj = {
        id: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true},
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_two, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64), Valid: true},
        haschild: {Int64: parseInt(1), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.parentid.Int64), Valid: true}
      }
      var newobj = {
        cusid: {Int64: parseInt(this.khid), Valid: true},
        name: {String: this.area_namethree, Valid: true},
        level: {Int64: parseInt(this.area_selectnode.level.Int64) + 1, Valid: true},
        haschild: {Int64: parseInt(0), Valid: true},
        parentid: {Int64: parseInt(this.area_selectnode.id.Int64), Valid: true}
      }
      newnode.push(oldobj)
      newnode.push(newobj)
      console.log(newnode)
      that.$http({
        url: 'https://api.sqnetsoft.cn/basedata/bapaau',
        method: 'post',
        data: newnode,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$http({
              url: 'https://api.sqnetsoft.cn/basedata/gbatree',
              method: 'post',
              data: {
                cusid: {Int64: parseInt(that.khid), Valid: true},
                parentid: {Int64: parseInt(-1), Valid: true}
              },
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                that.areadata = JSON.parse(res.data.data)
                that.$message({
                  type: 'success',
                  message: '修改成功!'
                })
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>
<style lang="css">
  .querypanel {
    margin-top: 10px;
    border: 1px solid #ebebeb;
    padding: 15px;
    border-radius: 3px;
    transition: .2s;
  }
  .curpointer {
    cursor: pointer;
  }
  .tablepanel {
    margin-top: 10px;
    margin-bottom: 20px;
    border: 1px solid #ebebeb;
    padding: 30px;
    border-radius: 3px;
    transition: .2s;
  }
  .querybtn {
    padding-left: 10px;
    margin-top: 10px;
  }
  .desinfo {
    margin-top: 10px;
    font-size: 8px;
    color:#1d9d74;
  }
  .leftpanel {
  }
  .rightpanel {
    padding-left: 30px;
  }
  .tabcard {
    padding: 20px;
  }
  .opicon{
    padding-left: 5px;
  }
  .desinfoex {
    margin-left: 10px;
    font-size: 9px;
    color:#1d9d74;
  }
</style>



// WEBPACK FOOTER //
// src/components/data/AllArea.vue